module.exports = __webpack_public_path__ + "img/ck.699bedf2.svg";